module.exports = __webpack_public_path__ + "img/LH.158bdb44.png";